import PropTypes from 'prop-types';
import { BsTable } from 'react-icons/bs';

import SectionCard from '#globalComponents/Card/SectionCard';

import { formatEurCompact, formatNumber } from '../../utils/formatters';

const ROWS = [
	{ key: 'revenue', label: 'Umsatz', format: formatEurCompact },
	{ key: 'earnings', label: 'Gewinn', format: formatEurCompact },
	{ key: 'balanceTotal', label: 'Bilanzsumme', format: formatEurCompact },
	{ key: 'equity', label: 'Eigenkapital', format: formatEurCompact },
	{ key: 'liabilities', label: 'Verbindlichkeiten', format: formatEurCompact },
	{ key: 'employeeCount', label: 'Mitarbeiter', format: formatNumber },
];

const MAX_YEARS = 6;

const isEstimated = (financial, key) =>
	Boolean(financial[`${key}IsEstimate`]) && financial[key] !== null && financial[key] !== undefined;

const EstimateLegend = () => (
	<span className="flex items-center gap-1.5 text-[11px] font-medium text-caution-700">
		<span className="inline-block h-2 w-2 rounded-full bg-caution-500" />
		Schätzung
	</span>
);

const CompanyFinancialTable = ({ financials }) => {
	const years = [...financials].reverse().slice(0, MAX_YEARS);
	const hasAnyEstimate = years.some((f) => ROWS.some((row) => isEstimated(f, row.key)));

	return (
		<SectionCard
			title="Bilanz & GuV"
			icon={BsTable}
			bodyClassName="overflow-x-auto p-0"
			headerAction={hasAnyEstimate && <EstimateLegend />}
		>
			<table className="w-full text-sm">
				<thead>
					<tr className="border-b border-bgBase-500">
						<th className="px-4 py-3 text-left text-xs font-semibold text-bgBase-800">Kennzahl</th>
						{years.map((f) => (
							<th
								key={f.year}
								className="whitespace-nowrap px-4 py-3 text-right text-xs font-semibold text-bgBase-800"
							>
								{f.year}
							</th>
						))}
					</tr>
				</thead>
				<tbody>
					{ROWS.map((row) => (
						<tr key={row.key} className="border-b border-bgBase-500 last:border-0">
							<td className="px-4 py-2.5 font-medium text-text">{row.label}</td>
							{years.map((f) => {
								const estimated = isEstimated(f, row.key);
								return (
									<td
										key={f.year}
										className={`whitespace-nowrap px-4 py-2.5 text-right ${
											estimated ? 'italic text-caution-700' : 'text-text'
										}`}
										title={estimated ? 'Geschätzter Wert' : undefined}
									>
										{row.format(f[row.key])}
									</td>
								);
							})}
						</tr>
					))}
				</tbody>
			</table>
		</SectionCard>
	);
};

CompanyFinancialTable.propTypes = {
	financials: PropTypes.array.isRequired,
};

export default CompanyFinancialTable;
